import React from "react";
import SectionTitle from "@others/title-section.layout";
import {Box, Chip, Container, Divider, Paper, Stack, Typography} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faDroplet,
    faBaby,
    faExclamationTriangle,
    faCalendarAlt,
    faEye,
    faBullhorn,
    faShieldAlt,
    faFileAlt,
    faEnvelope
} from "@fortawesome/free-solid-svg-icons";
// @ts-ignore
import oldLogo from "@logo/vld-2026.png";

const ARTICLE20251009: React.FC = () => {

    return(
        <Container maxWidth="lg" sx={{ mb: 6 }}>
            <SectionTitle title="ESPACE INFORMATIONS DES HABITANTS" />
            <Stack spacing={3}>
                <Box textAlign="center">
                    <img
                        src={oldLogo}
                        alt="Association Vivre la démocratie à BLR"
                        style={{ width: 300, marginBottom: 10, marginTop: 10 }}
                    />
                    <Typography
                        variant="h5"
                        color="primary"
                        fontWeight={700}
                        gutterBottom
                        sx={{ pt: 1, pb: 1 }}
                    >
                        Eau de Bois-le-Roi : exigeons la transparence
                    </Typography>
                </Box>
                <Divider />

                <Stack direction="row" spacing={1} alignItems="center" justifyContent="center" mb={1}>
                    <FontAwesomeIcon icon={faDroplet} color="#0288d1" />
                    <Typography variant="subtitle1" fontWeight={700} color="primary">
                        Une surveillance nécessaire depuis 2023
                    </Typography>
                </Stack>
                <Typography align="center" color="text.secondary">
                    Depuis 2023, la présence de perchlorates dans l'eau est surveillée. Un enjeu de santé publique qui mérite toute notre attention.
                </Typography>

                <Box sx={{ bgcolor: "#ffebee", borderRadius: 2, p: 2 }}>
                    <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                        <FontAwesomeIcon icon={faExclamationTriangle} color="#d32f2f" />
                        <Typography fontWeight={700} color="text.primary">
                            1er avril 2025 : dépassement confirmé
                        </Typography>
                    </Stack>
                    <Typography color="text.secondary" mb={1}>
                        Un prélèvement a confirmé un dépassement du seuil de précaution (<b>4 µg/L</b>).
                    </Typography>
                    <Stack direction="row" alignItems="center" spacing={1} mt={2}>
                        <FontAwesomeIcon icon={faBaby} color="#d32f2f" />
                        <Typography color="text.secondary">
                            Au-delà de ce seuil, l'eau n'est pas recommandée pour préparer les biberons des nourrissons &lt; 6 mois (Ministère de la Santé).
                        </Typography>
                    </Stack>
                </Box>

                <Box sx={{ bgcolor: "#fff3e0", borderRadius: 2, p: 2 }}>
                    <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                        <FontAwesomeIcon icon={faCalendarAlt} color="#f57c00" />
                        <Typography fontWeight={700} color="text.primary">
                            Un délai préoccupant
                        </Typography>
                    </Stack>
                    <Typography color="text.secondary">
                        Pourtant, l'information n'a été transmise aux habitants qu'à la <b>fin juin 2025</b>. Près de trois mois après le prélèvement.
                    </Typography>
                </Box>

                <Paper elevation={3} sx={{ mt: 3, p: 3, background: "linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)" }}>
                    <Stack spacing={3}>
                        <Stack direction="row" spacing={1.5} alignItems="center" justifyContent="center">
                            <FontAwesomeIcon icon={faBullhorn} color="#0d47a1" size="lg" />
                            <Typography fontWeight={700} variant="h6" color="#0d47a1">
                                La liste VLD2026 demande à la municipalité :
                            </Typography>
                        </Stack>

                        <Stack spacing={2}>
                            <Paper elevation={1} sx={{ p: 2, bgcolor: "white", borderLeft: "4px solid #1976d2" }}>
                                <Stack direction="row" alignItems="flex-start" spacing={2}>
                                    <Box sx={{ mt: 0.5 }}>
                                        <FontAwesomeIcon icon={faFileAlt} color="#1976d2" size="lg" />
                                    </Box>
                                    <Typography>
                                        <b>La publication de tous les bulletins ARS depuis 2023</b>
                                    </Typography>
                                </Stack>
                            </Paper>

                            <Paper elevation={1} sx={{ p: 2, bgcolor: "white", borderLeft: "4px solid #43a047" }}>
                                <Stack direction="row" alignItems="flex-start" spacing={2}>
                                    <Box sx={{ mt: 0.5 }}>
                                        <FontAwesomeIcon icon={faShieldAlt} color="#43a047" size="lg" />
                                    </Box>
                                    <Typography>
                                        <b>Un dispositif d'alerte rapide et systématique</b>
                                    </Typography>
                                </Stack>
                            </Paper>

                            <Paper elevation={1} sx={{ p: 2, bgcolor: "white", borderLeft: "4px solid #ffa000" }}>
                                <Stack direction="row" alignItems="flex-start" spacing={2}>
                                    <Box sx={{ mt: 0.5 }}>
                                        <FontAwesomeIcon icon={faEye} color="#ffa000" size="lg" />
                                    </Box>
                                    <Typography>
                                        <b>Une communication claire</b> envers les familles et les professionnels de santé
                                    </Typography>
                                </Stack>
                            </Paper>
                        </Stack>

                        <Divider sx={{ borderColor: "rgba(13, 71, 161, 0.2)" }} />

                        <Stack spacing={2} alignItems="center">
                            <Stack direction="row" alignItems="center" spacing={1}>
                                <FontAwesomeIcon icon={faDroplet} color="#0d47a1" />
                                <Typography fontWeight={600} color="#0d47a1" fontSize="1.1rem">
                                    La santé publique n'attend pas.
                                </Typography>
                            </Stack>
                            <Chip
                                icon={<FontAwesomeIcon icon={faEye} />}
                                label="Transparence = confiance"
                                sx={{
                                    fontWeight: 700,
                                    fontSize: "1.1rem",
                                    background: "white",
                                    color: "#0d47a1",
                                    py: 2.5,
                                    px: 2,
                                    borderRadius: "20px",
                                    boxShadow: "0 2px 8px rgba(13, 71, 161, 0.2)"
                                }}
                            />
                        </Stack>
                    </Stack>
                </Paper>

                {/* Section mail */}
                <Stack direction="row" spacing={1} alignItems="center" justifyContent="center" mb={2} mt={3}>
                    <FontAwesomeIcon icon={faEnvelope} color="#1976d2" size="lg" />
                    <Typography variant="h6" fontWeight={700} color="primary">
                        Copie du mail adressé au Maire et aux élus municipaux
                    </Typography>
                </Stack>
                <Typography align="center" variant="subtitle2" color="text.secondary" mb={2}>
                    22 septembre 2025
                </Typography>

                <Paper elevation={2} sx={{ p: 3, bgcolor: "#fafafa" }}>
                    <Typography fontWeight={700} gutterBottom color="primary">
                        Objet : Qualité de l'eau à Bois-le-Roi – Demande de clarification et de transparence
                    </Typography>

                    <Typography paragraph sx={{ mt: 2 }}>
                        Monsieur le Maire, Mesdames et Messieurs les élus municipaux,
                    </Typography>

                    <Typography paragraph>
                        Nous souhaitons, par ce courrier, vous faire part de notre profonde préoccupation concernant la gestion de l'information relative à la qualité de l'eau potable à Bois-le-Roi, et en particulier la présence de perchlorates en concentrations supérieures à la valeur guide provisoire de 4 µg/L.
                    </Typography>

                    <Typography paragraph>
                        Selon les documents de l'Agence Régionale de Santé (ARS), cette valeur guide constitue un seuil de précaution : <b>au-delà de 4 µg/L, l'eau ne doit pas être utilisée pour la préparation des biberons destinés aux nourrissons de moins de six mois</b> (Ministère de la Santé, recommandations nationales sur les perchlorates).
                    </Typography>

                    <Typography paragraph>
                        À Bois-le-Roi, la question fait l'objet d'un suivi depuis 2023, et un prélèvement du <b>1er avril 2025</b> a mis en évidence un dépassement de ce seuil (communiqué municipal du 25 juin 2025). Or, à notre connaissance, une information large de la population n'a été diffusée qu'à la fin juin 2025 (courrier de Veolia daté du 27 juin 2025, relayé par la mairie). Nous n'avons trouvé aucune trace de communication antérieure destinée aux familles concernées, aux professionnels de santé ou aux élus municipaux non exécutifs.
                    </Typography>

                    <Box sx={{ bgcolor: "#e3f2fd", borderRadius: 1, p: 2, my: 2 }}>
                        <Typography>
                            Cette chronologie soulève de légitimes interrogations sur la chaîne de transmission de l'information et sur le respect des obligations de transparence prévues par <b>l'article D1321-104 du Code de la santé publique</b> (information du public dans les 24 heures en cas de dépassement affectant la santé des nourrissons).
                        </Typography>
                    </Box>

                    <Typography paragraph fontWeight={600} sx={{ mt: 3 }}>
                        Dans ce contexte, nous sollicitons des réponses claires aux questions suivantes :
                    </Typography>

                    <Stack component="ol" spacing={1.5} sx={{ pl: 3 }}>
                        <Typography component="li">
                            La mairie de Bois-le-Roi a-t-elle bien reçu les bulletins de l'ARS relatifs aux perchlorates en 2023 et 2024 ?
                        </Typography>
                        <Typography component="li">
                            Si oui, pourquoi ces bulletins n'ont-ils pas été portés à la connaissance de la population dans le délai légal de 24 heures ?
                        </Typography>
                        <Typography component="li">
                            Le maire de Bois-le-Roi, également vice-président de la CAPF en charge de la santé, a-t-il été informé de ces dépassements ? Quelles mesures ont alors été prises ?
                        </Typography>
                        <Typography component="li">
                            Quel dispositif est aujourd'hui prévu pour garantir une information rapide et fiable en cas d'alerte sanitaire similaire ?
                        </Typography>
                    </Stack>

                    <Typography paragraph fontWeight={600} sx={{ mt: 3 }}>
                        Dans un souci de responsabilité collective et de restauration de la confiance, nous demandons :
                    </Typography>

                    <Stack component="ul" spacing={1.5} sx={{ pl: 3 }}>
                        <Typography component="li">
                            La publication de l'ensemble des bulletins ARS reçus concernant la qualité de l'eau à Bois-le-Roi depuis 2023 ;
                        </Typography>
                        <Typography component="li">
                            Une communication officielle, claire et détaillée, sur les dépassements enregistrés, les mesures prises ou non, et les actions envisagées ;
                        </Typography>
                        <Typography component="li">
                            La mise en place d'un protocole d'alerte systématique et public, en lien avec les professionnels de santé et les acteurs de la petite enfance.
                        </Typography>
                    </Stack>

                    <Typography paragraph sx={{ mt: 3 }}>
                        Nous espérons que ces demandes seront entendues et traitées rapidement. <b>La santé publique ne peut souffrir de délais injustifiés ni d'un déficit d'information.</b>
                    </Typography>

                    <Typography paragraph>
                        Nous vous remercions par avance pour vos réponses.
                    </Typography>

                    <Typography paragraph>
                        Dans cette attente, nous vous prions d'agréer, Monsieur le Maire, Mesdames et Messieurs les élus municipaux, l'expression de nos salutations distinguées.
                    </Typography>

                    <Typography fontWeight={600} sx={{ mt: 3 }}>
                        Jean-Philippe Guibert
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Pour l'Association Vivre la démocratie à BLR
                    </Typography>
                </Paper>

                <Typography align="center" variant="subtitle2" sx={{ fontStyle: "italic", mt: 3 }}>
                    Votre équipe VLD2026
                </Typography>
            </Stack>
        </Container>
    )
}

export default ARTICLE20251009;